import topic from '../topic';
import { getNoCatch } from '@api/request';

export const recordAPI = {
  getRecordRemindTotalByStatus: params => getNoCatch(`${topic.recordTopic}/getRecordRemindTotalByStatus`, params),
  getRecordRemindListByStatus: params => getNoCatch(`${topic.recordTopic}/getRecordRemindListByStatus`, params),
  getNeedleRecordList: params => getNoCatch(`${topic.recordTopic}/getNeedleRecordList`, params)
};
